export default {
    setEnabled: {
        success: 'Status changed successfully',
        error: 'Error while changing the status'
    },

    removeParticipants: {
        success: 'All participations removed successfully',
        error: 'Error while removing the participations'
    },

    updateFeedbackIntroText: {
        success: 'Feedback intro text updated successfully',
        error: 'Error while customizing feedback intro text'
    },

    setFeedbackEnabled: {
        success: 'Feedback status changed successfully',
        error: 'Error while changing the feedback status'
    },

    updateIntroTranslations: {
        success: 'Welcome text was successfully edited',
        error: 'Error while editing the welcome text'
    },

    updateLogo: {
        success: 'Logo was successfully edited',
        error: 'Error while editing the logo'
    },

    deleteLogo: {
        success: 'Logo was successfully deleted',
        error: 'Error while deleting the logo'
    }
}
